import { DiagramNode } from "@/app/features/diagrams/components/shared/DiagramNode";

// The delivery fan-out is a distinct visual layer below the publication-model
// seam; keeping it separate makes the pipeline's pivot explicit in code too.
export function S1000DDeliveryTargets() {
  return (
    <>
      <path
        d="M 350 366 L 350 396"
        fill="none"
        stroke="var(--ga-brass, #9c6b3e)"
        strokeWidth="1.8"
      />
      <path
        d="M 350 396 L 150 396 L 150 428"
        fill="none"
        stroke="#10b981"
        strokeWidth="1.6"
        opacity="0.9"
        markerEnd="url(#s1k-arrow-green)"
      />
      <path
        d="M 350 396 L 350 428"
        fill="none"
        stroke="#10b981"
        strokeWidth="1.6"
        opacity="0.9"
        markerEnd="url(#s1k-arrow-green)"
      />
      <path
        d="M 350 396 L 550 396 L 550 428"
        fill="none"
        stroke="#10b981"
        strokeWidth="1.6"
        strokeDasharray="5 4"
        opacity="0.9"
        markerEnd="url(#s1k-arrow-green)"
      />
      <circle cx="350" cy="396" r="3.5" fill="var(--ga-brass, #9c6b3e)" />
      <DiagramNode
        x={50}
        y={430}
        width={200}
        height={52}
        label="Web Publication"
        sublabel="Search · Navigation"
        variant="success"
      />
      <DiagramNode
        x={260}
        y={430}
        width={180}
        height={52}
        label="Offline Package"
        sublabel="Content + Indexes"
        variant="success"
      />
      <DiagramNode
        x={450}
        y={430}
        width={200}
        height={52}
        label="Downstream Systems"
        sublabel="Maintenance · Training"
        variant="success"
      />
    </>
  );
}
